// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".LRCFixer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  padding-top: 81px;\n  background-color: #e4dcdc;\n}\n\ntextarea{\n  flex-grow: 1;\n}", ""]);
// Exports
module.exports = exports;
